import React, { useRef, useEffect } from 'react'
import styles from './DialogShell.module.scss'

interface DialogShellProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  className?: never
}

export const DialogShell: React.FC<DialogShellProps> = ({
  open, onClose, children,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => { document.body.style.overflow = '' }
  }, [open])

  if (!open) return null

  return (
    <div className={styles.overlay} onClick={(e) => { if (e.target === overlayRef.current) onClose() }} ref={overlayRef}>
      <div className={styles.dialog}>{children}</div>
    </div>
  )
}
